import { cn } from "@/lib/utils";

interface StatusDotProps {
  status: "connected" | "disconnected" | "error";
  className?: string;
  showLabel?: boolean;
}

const statusConfig = {
  connected: {
    color: "bg-emerald-400",
    ring: "ring-emerald-400/30",
    label: "Conectado",
    pulse: true,
  },
  disconnected: {
    color: "bg-zinc-500",
    ring: "ring-zinc-500/30",
    label: "Desconectado",
    pulse: false,
  },
  error: {
    color: "bg-rose-400",
    ring: "ring-rose-400/30",
    label: "Erro",
    pulse: true,
  },
};

export function StatusDot({ status, className, showLabel }: StatusDotProps) {
  const config = statusConfig[status];

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <span className="relative flex h-2.5 w-2.5">
        {config.pulse && (
          <span
            className={cn(
              "absolute inline-flex h-full w-full rounded-full opacity-75 animate-pulse-dot",
              config.color
            )}
          />
        )}
        <span
          className={cn(
            "relative inline-flex h-2.5 w-2.5 rounded-full ring-2",
            config.color,
            config.ring
          )}
        />
      </span>
      {showLabel && (
        <span className="text-xs text-muted-foreground">{config.label}</span>
      )}
    </div>
  );
}
